// extracted by mini-css-extract-plugin
module.exports = {"body":"VerticalBarGraph_body__3p7Jj","pdfBody":"VerticalBarGraph_pdfBody__17HNt"};